import { capturePostHogEvent } from "./posthog";

export type InvoiceExportTarget = "excel" | "qbo" | "xero" | "iif" | "csv";

type CommonProps = {
  target: InvoiceExportTarget;
  [key: string]: unknown;
};

export const trackInvoiceExportModalOpened = (props: {
  target: InvoiceExportTarget;
  invoiceCount?: number;
  hasErrors?: boolean;
}) => {
  capturePostHogEvent("invoice_export_modal_opened", props);
};

export const trackInvoiceExportAttempted = (props: CommonProps & {
  invoiceCount?: number;
  fieldMapping?: string;
}) => {
  capturePostHogEvent("invoice_export_attempted", props);
};

export const trackInvoiceExportSucceeded = (props: CommonProps & {
  invoiceCount?: number;
  durationMs?: number;
}) => {
  capturePostHogEvent("invoice_export_succeeded", props);
};

export const trackInvoiceExportFailed = (props: CommonProps & {
  errorCode?: string | number;
  errorMessage?: string;
  durationMs?: number;
}) => {
  capturePostHogEvent("invoice_export_failed", props);
};

export const trackInvoiceExportCanceled = (props: CommonProps & {
  step?: string;
}) => {
  capturePostHogEvent("invoice_export_canceled", props);
};
